import { Component } from '@verndale/core';
import MicroModal from 'micromodal';
import Cookies from 'js-cookie';
import Axios from 'axios';
import { isValid } from '../components/eloqua-form';
import { dispatchGenericEvent } from '../utils/dispatch-events';
import { isTabletLandscapeUp } from '../utils/breakpoints';
import { constEvent } from '../utils/constants';

class Module extends Component {
  setupDefaults() {
    this.id = this.el.id;
    this.dom = {
      $iframe: this.el._$('.eloqua-modal__iframe'),
      $closeButton: this.el._$('.eloqua-modal__close'),
      $overlay: this.el._$('.eloqua-modal__overlay'),
      $modal: this.el._$('.eloqua-modal__container'),
      $form: this.el.getElementsByTagName('form')[0]
    };
  }

  addListeners() {
    const { $closeButton, $form, $iframe } = this.dom;
    this.el._on(constEvent.OPEN_ELOQUA_IFRAME_MODAL, this.openModal.bind(this));
    this.el._on(
      constEvent.CLOSE_ELOQUA_IFRAME_MODAL,
      this.closeModal.bind(this)
    );
    document._on('click', this.onModalTriggerClick.bind(this));
    document.addEventListener('message', e => {
      console.log(e);
    });
    $iframe?._on('load', () => this.removeLoader());
    // $closeButton._on('click', () => {
    //   this.closeModal(this);
    //   dispatchGenericEvent(constEvent.CLOSED_ELOQUA_MODAL, {}, this.el);
    // });
    // $form._on('submit', this.handleSubmit.bind(this));
  }

  onModalTriggerClick(e) {
    const el = e.target.closest(`[data-micromodal-trigger="${this.id}"]`);
    if (!el) return;
    this.openModal();
  }

  openModal(e) {
    const { $iframe } = this.dom;
    if (!$iframe) return;

    if (isTabletLandscapeUp) {
      document.body.style.overflow = 'hidden';
    }

    this.addLoader();
    $iframe.src = e?.detail?.url;

    $('.eloqua-modal__overlay').removeAttr('data-eloqua-modal-close');
    $('.generic-modal__overlay').removeAttr('data-generic-modal-close');

    MicroModal.show(this.id, {
      openClass: 'eloqua-modal--open',
      onClose: () => ($iframe.src = 'about:blank')
    });
  }

  closeModal() {
    if (isTabletLandscapeUp) {
      document.body.style.overflow = '';
    }
    MicroModal.close(this.id);
  }

  handleSubmit() {
    if (!isValid(this.dom.$form)) return;
    this.closeModal();
  }

  addLoader() {
    const { $modal } = this.dom;
    $modal?.insertAdjacentHTML(
      'beforeend',
      '<div class="full-size-loader full-size-loader--white-bg"><div class="loader"></div></div>'
    );
  } //addLoader

  removeLoader() {
    const { $modal } = this.dom;
    $modal?._$('.full-size-loader')?.remove();
  } //removeLoader
}

export default Module;
